import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useInView } from 'react-intersection-observer'

import { Layout, Header } from 'app/theme/layout'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import ImageHero from 'app/theme/ImageHero'
import { OccasionPageGrid, OccasionPageGridRow } from '../occasions/shared/OccasionPageGrid'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import OccasionsSlider from 'app/theme/sections/CateringOccasionsSlider'
import Calculator from 'app/theme/calculator'

import heroImg from 'assets/img/film-prod-city-page-hero.jpg'
import gridImage1 from 'assets/img/film-production-grid-1.jpg'
import gridImage2 from 'assets/img/film-production-grid-2.jpg'
import gridImage3 from 'assets/img/film-production-grid-3.jpg'
import gridImage4 from 'assets/img/film-production-grid-4.jpg'
import gridImage5 from 'assets/img/film-production-grid-5.jpg'
import gridImage6 from 'assets/img/film-production-grid-6.jpg'

export default function FilmProductionLAPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Catering for TV and Film Production in LA (Food Trucks) - Roaming Hunger</title>
        <meta name="og:title" content="Catering for TV and Film Production in LA (Food Trucks)"></meta>
        <meta name="description" content="Looking for mobile film production catering? Food trucks are a great way to provide TV/movie set catering in Los Angeles. Book fun film catering."></meta>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={heroImg}
          title="TV & Film Catering in Los Angeles"
          onButtonClick={openModal}
          description={(
            <div>
              Whether you're on the lot or on location, Roaming Hunger makes production
              catering in Los Angeles turnkey with delicious food trucks.
            </div>
          )}
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="24 Hour Production Catering"
          content="Fuel your cast and crew with full meals or quick service items like coffee and snacks. We offer famous, on-trend food trucks that provide 24 hour production catering flexibility. Decide if you want buffet style service or order directly from the truck, and it's a wrap."
          image={gridImage1}
          reverse
        />
        <OccasionPageGridRow
          heading="Be The Star"
          content="Make the catering experience the center of your set's social scene by booking food trucks that the entire cast and crew will love. With hundreds of well-known and delicious trucks in LA, we have the lobster roll or taco that everyone will go crazy for. You will be the biggest star on set."
          image={gridImage2}
        />
      </OccasionPageGrid>

      <FeaturedClients
        onButtonClick={openModal}
      />

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="We Handle the Hard Part"
          content="Make catering for your cast and crew the easiest part of your day. We reach out to the most reliable trucks in LA, negotiate the best prices, and handle all the transactions. Just tell us what you want and we'll help you get back to more important tasks."
          image={gridImage3}
          reverse
        />
        <OccasionPageGridRow
          heading="Service Guarantee"
          content="Book your production catering with confidence knowing we have established relationships with the best food trucks in LA. We hold all funds until after your event, so we can guarantee you will get fantastic customer service every time."
          image={gridImage4}
        />
      </OccasionPageGrid>

      <WhyWorkWithUs
        onButtonClick={openModal}
      />

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Craft Services, done right."
          content="Looking to expand your craft services options? Give your cast and crew a fresh acai bowl instead of that boring bagel. Choose from hundreds of grab-and-go food options, brought direct to your tv or movie set."
          image={gridImage5}
          reverse
        />
        <OccasionPageGridRow
          heading="It's a Wrap!"
          content="Celebrate your final production day or wrap party with the best food truck catering in Los Angeles. With thousands of well-known and delicious trucks in our network, we have the lobster roll or taco that everyone will go crazy for."
          image={gridImage6}
        />
      </OccasionPageGrid>

      <CuisineTypes baseUrl='/food-truck-catering' />

      <HowItWorks
        heading="How Production Catering in Los Angeles Works"
        onButtonClick={openModal}
      />
      <HowItWorksLarge
        heading="How Production Catering in Los Angeles Works"
        onButtonClick={openModal}
      />

      <Calculator
        heading="How Much Does Production Catering in Los Angeles Cost?"
        onButtonClick={openModal}
      />

      <OccasionsSlider
        className="bg-white py-12"
      />
    </Layout>
  )
}
